/**
 * Gets the microfrontend cdn url and ads the current path as HASH.
 */
export const getMicroFrontendURL = (url: string | null, location: { pathname: string; search: string }): string => {
  return `${url}#${location.pathname}${location.search}`;
};
